// Окно «Сессия истекла» (задача D4): любой запрос получил 401 — поверх экрана открывается вход.
//
// Экран под окном остаётся смонтированным: набранный текст на месте. После входа окно закрывается, фокус
// возвращается туда, где был (Base UI), а данные экрана перезапрашиваются (`useLogin`). Esc и щелчок мимо окно
// не закрывают: без входа работать нельзя — либо «Войти», либо «Выйти» (на `/login`).
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { LoginForm } from './login-form';
import { closeSessionExpired, useSessionExpired } from './session';

export function SessionExpiredDialog() {
  const open = useSessionExpired();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  async function logOut(): Promise<void> {
    closeSessionExpired();
    // Сначала уходим с экранов пульта, потом чистим кэш: открытый экран не успеет перезапросить свои данные.
    await navigate('/login', { replace: true });
    queryClient.clear();
  }

  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-hotkeys="off">
        <AlertDialogHeader>
          <AlertDialogTitle>Сессия истекла</AlertDialogTitle>
          <AlertDialogDescription>
            Войдите снова, чтобы продолжить. Несохранённые правки на экране останутся.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <LoginForm
          layout="dialog"
          secondaryAction={
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={() => {
                void logOut();
              }}
            >
              Выйти
            </Button>
          }
        />
      </AlertDialogContent>
    </AlertDialog>
  );
}
